var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.block.data.audio)?_c('AIInfoCard'):_c('div',[_c('block-audio-viewer',{attrs:{"value":_vm.block}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }